__turbopack_context__.v({
  "checkboxValues": "kiRKaG_checkboxValues",
  "confirmationTitle": "kiRKaG_confirmationTitle",
  "field": "kiRKaG_field",
  "key": "kiRKaG_key",
  "textareaValue": "kiRKaG_textareaValue",
  "value": "kiRKaG_value",
});
